import {getQuery} from "../../common/utils";
const Qs = require('qs');

const get = async (page, per_page, search_expression, states, staff_ids, start_time, end_time, sort_direction, waitlist) => {
  const params = {
    entity: 'event_instance',
    page: page || 1,
    per_page: per_page || 20,
  };

  if (search_expression) {
    params.query = search_expression;
  }

  const search_filter = {};

  search_filter.sort_type = "start_time";

  search_filter.sort_order = sort_direction;

  search_filter.state_filter = states.join();

  search_filter.waitlist = waitlist.join();

  if (start_time) {
    search_filter.from_filter = start_time;
  }

  if (end_time) {
    search_filter.to_filter = end_time;
  }

  if (staff_ids && staff_ids.length > 0) {
    search_filter.staff_filter = staff_ids.join();
  }

  if (Object.keys(search_filter).length > 0) {
    params.search_filter = search_filter;
  }

  let result;
  try {
    result = await getQuery('search', params, params => Qs.stringify(params, {arrayFormat: 'brackets'}));
    result = result.data;
    result.events = result.events.map(item => {return {...item, id: item.uid}});
  }
  catch (error) {
    result = {code: 'missing'};
  }

  return result;
};

export const eventsService = {
  get
};
